import styled from 'styled-components/macro';
import { RadioButton } from '@yme/atoms/radio-button';
import { colorBlackTransparent50, colorCoreBlack300, colorCoreBlack900Base, colorCoreGray100, colorCoreGray500, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingLevel3 } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const PaymentFormWrapper = styled.div `
  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl'};
`;
export const PaymentStyled = styled.div `
  background: ${colorCoreGray100};
  margin-bottom: 48px;
`;
export const PaymentTitleStyled = styled(HeadingLevel3) `
  margin: 48px 0 8px;
`;
export const PaymentSubTitleStyled = styled.p `
  ${getTextStyles('Ubuntu', 400, 16, 24)}
  color: ${colorCoreBlack300};
  margin: 0;
  padding: 0 0 ${INDENT.m} 0;
`;
export const RadioButtonGroupStyled = styled.div `
  border-radius: ${CORNER_RADIUS.s};
  margin-bottom: ${INDENT.m};
  & > div {
    border: 1px solid ${colorCoreGray500};
  }
  & > div:first-child {
    border-radius: ${CORNER_RADIUS.s} ${CORNER_RADIUS.s} 0 0;
  }
  & > div:last-child {
    border-radius: 0 0 ${CORNER_RADIUS.s} ${CORNER_RADIUS.s};
    > &:not(.active-payment) {
      border-top: 0;
    }
  }
`;
export const RadioButtonStyled = styled(RadioButton) `
  padding: 18px;
  background: ${({ isActive }) => (isActive ? colorBlackTransparent50 : '')};
  &:first-child:not(.active-payment) {
    border-bottom: 0 none;
  }
  & {
    border-bottom: 1px solid ${colorCoreGray500};
  }
  &.active-payment {
    border: 1px solid ${colorCoreBlack900Base};
  }
  &.active-last-payment:not(.active-payment) {
    border-top: 1px solid transparent;
    border-bottom: 1px solid ${colorCoreGray500};
  }
  & span span {
    flex-flow: column wrap;
    align-items: baseline;
    user-select: none;
  }
`;
export const DescriptionStyled = styled.span `
  ${getTextStyles('Ubuntu', 400, 14, 20)}
  color: ${colorCoreBlack300};
`;
